// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const fromEntries = (pairs) => {
    if (Object.fromEntries) {
        return Object.fromEntries(pairs);
    }
    return pairs.reduce(
        (accum, [id, value]) => ({
            ...accum,
            [id]: value,
        }),
        {},
    );
};
